import { createSlice } from '@reduxjs/toolkit'
import { PlanDetail } from 'models'

type initialStateType = {
  mccsFromPhoto: MccItem[]
  selectedMccFromPhoto?: string
  selectedMccCode?: string
  uploadImageCaptureDetail: {
    selfie: DocumentState
    stock: DocumentState
    // shop: DocumentState
    shopPhotos: DocumentState
    operating: DocumentState
    pan: DocumentState
    cheque: DocumentState
    form: DocumentState
    statement: DocumentState
    emailDoc: DocumentState
    deedDoc: DocumentState
    declarationDoc: DocumentState
  }
  uploadImgDetail: any
  productsNotEligible: PlanDetail[]
}
interface MccItem {
  mccCode: string
  confidenceScore: string
}
export interface DocumentState {
  imgName: string
  imgUrl?: string
  modified: boolean
  imgUrls?: string[]
  imgSource?: string
}
// Document keys used in redux store
// don't add any other keys here
export const DocumentsReduxKey = {
  selfie: 'selfie',
  operatingLicense: 'operating',
  stock: 'stock',
  displayboard: 'shopPhotos',
  bankStatement: 'statement',
}

const initialState = {
  mccsFromPhoto: [],
  selectedMccCode: '',
  selectedMccFromPhoto: '',
  productsNotEligible: [],
  uploadImageCaptureDetail: {
    selfie: {
      imgName: null,
      imgUrl: null,
      modified: false,
      imgUrls: [],
    },
    stock: {
      imgName: null,
      imgUrl: null,
      modified: false,
      imgUrls: [],
    },
    shopPhotos: {
      imgName: null,
      modified: false,
      imgUrls: [],
    },
    statement: {
      imgName: null,
      imgUrl: null,
      modified: false,
      imgUrls: [],
    },
    operating: {
      imgName: null,
      imgUrl: null,
      modified: false,
      imgUrls: [],
    },
    pan: {
      imgName: null,
      imgUrl: null,
      modified: false,
    },
    cheque: {
      imgName: null,
      imgUrl: null,
      modified: false,
    },
    form: {
      imgName: null,
      imgUrl: null,
      modified: false,
    },
    deedDoc: {
      imgName: null,
      imgUrl: null,
      modified: false,
    },
    declarationDoc: {
      imgName: null,
      imgUrl: null,
      modified: false,
    },
  },
  uploadImgDetail: {
    imgName: null,
    imgUrl: null,
  },
} as initialStateType

const photoSlice = createSlice({
  name: 'photo',
  initialState: initialState,
  reducers: {
    setDifferentMccFromPhoto: (state, action) => {
      state.mccsFromPhoto = action.payload
    },
    setSelectedMccCode: (state, action) => {
      state.selectedMccCode = action.payload
    },
    setCaptureImageDetail: (state, action) => {
      state.uploadImageCaptureDetail = { ...state.uploadImageCaptureDetail, ...action.payload }
    },
    setUploadImageDetail: (state, action) => {
      state.uploadImgDetail.imgName = action.payload.imgName
      state.uploadImgDetail.imgUrl = action.payload.imgUrl
    },
    setMccFromPhoto: (state, action) => {
      state.selectedMccFromPhoto = action.payload
    },
    setProductsNotEligible: (state, action) => {
      state.productsNotEligible = action.payload
    },
    obseleteData: (state, action) => {
      state.mccsFromPhoto = []
      state.selectedMccCode = ''
      state.uploadImageCaptureDetail = initialState.uploadImageCaptureDetail
    },
  },
})

export const {
  setDifferentMccFromPhoto,
  setSelectedMccCode,
  setCaptureImageDetail,
  setUploadImageDetail,
  setMccFromPhoto,
  setProductsNotEligible,
  obseleteData,
} = photoSlice.actions

export const photo = (state) => state.photo

export default photoSlice.reducer
